module.exports = __webpack_public_path__ + "static/media/footer-degrade.febd1fb0.svg";